import { render, staticRenderFns } from "./mobile-institution-tab.vue?vue&type=template&id=7b5cd232&scoped=true"
import script from "./mobile-institution-tab.vue?vue&type=script&lang=js"
export * from "./mobile-institution-tab.vue?vue&type=script&lang=js"
import style0 from "./mobile-institution-tab.vue?vue&type=style&index=0&id=7b5cd232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5cd232",
  null
  
)

export default component.exports